import React, { useState, useEffect, SetStateAction, Dispatch } from "react";
import getModalStyle from "../../../../util/getModalStyle";
import api from "../../../../api/api";
import { validateEmail, removeEmail, addEmail } from "./customerEmail.biz";

function useCustomerEmailSelector(
  pdfObj: { [key: string]: any },
  customerEmail: string,
  dealerEmail: string,
  fileName: string,
  open: boolean,
  handleClose: () => void,
  type?: string,
) {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const [to, setTo] = useState<string[]>([]);

  const [newTo, setNewTo] = useState("");

  const [showToTextBox, setShowToTextBox] = useState(false);

  const [cc, setCC] = useState<string[]>([]);

  const [newCC, setNewCC] = useState("");

  const [showCCTextBox, setShowCCTextBox] = useState(false);

  const [subject, setSubject] = useState("AG Millworks Quote");

  const [emailBody, setBody] = useState("");

  const [filename, setFilename] = useState("");

  const [editFile, setEditFile] = useState(false);

  const [load, setLoad] = useState(false);

  const [error, setError] = useState(false);

  const [openSnack, setOpenSnack] = useState(false);

  const handleOpenSnack = () => setOpenSnack(true);
  const handleCloseSnack = () => setOpenSnack(false);

  const handleChangeFilename = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilename(e.target.value);
  };

  const showTo = () => {
    if (to.length > 5) {
      return alert("Can't have more than 6 recipients");
    }

    setShowToTextBox(true);
  };

  const showCC = () => {
    if (cc.length > 5) {
      return alert("Can't have more than 6 recipients");
    }

    setShowCCTextBox(true);
  };

  const addCC = () => {
    const trimmed = newCC.trim();
    if (!trimmed) {
      return;
    }
    if (!validateEmail(trimmed)?.length) {
      return alert("Must be a valid email address");
    }
    setCC(addEmail(cc, trimmed));
    setNewCC("");
    setShowCCTextBox(false);
  };

  const removeCC = (deleteEmail: string) => {
    setCC(removeEmail(cc, deleteEmail));
  };

  const addRecipient = () => {
    const trimmed = newTo.trim();
    if (!trimmed) {
      return;
    }
    if (!validateEmail(trimmed)?.length) {
      return alert("Must be a valid email address");
    }
    setTo(addEmail(to, trimmed));
    setNewTo("");
    setShowToTextBox(false);
  };

  const allowEnterTo = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      addRecipient();
    }
  };

  const allowEnterCC = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      addCC();
    }
  };

  const removeRecipient = (deleteEmail: string) => {
    setTo(removeEmail(to, deleteEmail));
  };

  const handleChange =
    (setter: Dispatch<SetStateAction<string>>) =>
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setter(event.target.value);
    };

  const handleSend = async () => {
    if (!to?.length) {
      return alert("Please provide at least 1 email recipient");
    }
    setLoad(true);

    try {
      const url =
        type === "insights"
          ? "/api/insights/sendInsightsPDF"
          : "/api/sendCustomerPDF";

      const args = {
        ...pdfObj,
        emailBody,
        to,
        cc,
        subject,
        filename: `${filename}.pdf`,
      };

      await api.post(url, args);
      setError(false);
      handleOpenSnack();
      handleClose();
    } catch (err) {
      console.log(err);
      setError(true);
    }finally {
      setLoad(false)
    }
  };

  useEffect(() => {
    setTo(customerEmail ? [customerEmail] : []);
    setCC(dealerEmail ? [dealerEmail] : []);
    setNewCC("");
    setNewTo("");
    setLoad(false);
    setError(false);
    setSubject(
      type === "insights" ? "AG Millworks Insights" : "AG Millworks Quote"
    );
    setBody("");
    setEditFile(false);
    setFilename(fileName.replace(".pdf", ""));
  }, [open]);

  return {
    handleSend,
    handleChange,
    removeCC,
    removeRecipient,
    allowEnterCC,
    allowEnterTo,
    showCC,
    showTo,
    handleChangeFilename,
    handleCloseSnack,
    openSnack,
    error,
    load,
    editFile,
    filename,
    emailBody,
    subject,
    showCCTextBox,
    newCC,
    cc,
    showToTextBox,
    newTo,
    to,
    modalStyle,
    setNewTo,
    addRecipient,
    setNewCC,
    addCC,
    setSubject,
    setEditFile,
    setBody,
  };
}

export default useCustomerEmailSelector;
